import { render, staticRenderFns } from "./EditBoccoChannelVUI.vue?vue&type=template&id=15cd24aa&scoped=true&"
import script from "./EditBoccoChannelVUI.vue?vue&type=script&lang=ts&"
export * from "./EditBoccoChannelVUI.vue?vue&type=script&lang=ts&"
import style0 from "./EditBoccoChannelVUI.vue?vue&type=style&index=0&id=15cd24aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd24aa",
  null
  
)

export default component.exports